import styled from 'styled-components';

export const Container = styled.div`
  .ReactPasswordStrength {
    border-radius: 4px !important; 
    border: 1px solid  #d9d9d9;   
    :hover{
      border: 1px solid #c6c6c6;
    }
  }
  .ReactPasswordStrength-input {
    padding: 6px 0px 6px 8px !important;  
    background: none !important;
    width:75%;
    display:flex;
    ::placeholder{
    font-size:16px;
    font-family: sans-serif !important;
    font-weight: 400;
    opacity:0.6
    }
  }
  .ReactPasswordStrength-strength-desc {
    width:25% !important; 
    padding:8px  !important;
  }
  ReactPasswordStrength-strength-bar{
  width:100%;
  }
`;
